<template>
  <v-dialog
    v-model="checkInDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="checkInDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>החזרה</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="loading"
          :disabled="loading"
          @click="checkIn"
        >
          ביצוע החזרה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-alert
          prominent
          type="info"
          v-if="isWrongCheckInDate"
        >
          תאריך ההחזרה לא תואם את ההזמנה.
        </v-alert>
      </v-card-text>
      <v-card-text class="pt-0">
        <v-textarea
          v-model="editableResource.customerComments"
          label="הערות לקוח"
          :rows="2"
        ></v-textarea>
        <v-textarea
          v-model="editableResource.agentComments"
          label="הערות נציג"
          :rows="2"
        ></v-textarea>
      </v-card-text>
      <v-card-text>
        <h3 class="title black--text">פרטי נציג</h3>
        <v-text-field
          label="מזהה נציג"
          v-model="editableResource.agentId"
        ></v-text-field>
        <v-select
          :items="stores"
          item-value="_id"
          item-text="title"
          label="חנות"
          v-model="editableResource.agentStore"
        ></v-select>
      </v-card-text>
      <v-card-text>
        <h3 class="title black--text">פעולות נלוות</h3>
        <v-checkbox
          v-model="editableResource.sendMessagesToCustomers"
          color="primary"
          :label="`שליחת הודעות ללקוח`"
        ></v-checkbox>
        <v-checkbox
        class="mt-0"
          v-model="editableResource.createTasks"
          color="primary"
          :label="`יצירת משימות`"
        ></v-checkbox>
        <v-checkbox
        class="mt-0"
          v-model="editableResource.doStoreTransfer"
          color="primary"
          :label="`ביצוע העברת חנות למכשיר`"
        ></v-checkbox>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import { differenceInCalendarDays } from "date-fns";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      loading: false,
      editableResource: {}
    };
  },

  computed: {
    checkInDialog: {
      get() {
        return this.$store.state.checkInDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_CHECK_IN_DIALOG", isActive);
      }
    },
    order() {
      return this.$store.state.entities.orders[this.orderId];
    },
    isWrongCheckInDate() {
      if (this.order) {
        let orderEndDate = this.order.endDate;
        return (
          differenceInCalendarDays(new Date(), new Date(orderEndDate)) != 0
        );
      }
      return false;
    },
    stores() {
      return Object.values(this.$store.state.entities.stores).sort((a,b) => {
        return (a.title > b.title) ? 1 : -1;
      });
    }
  },

  methods: {
    checkIn() {
      this.loading = true;

      getApi()
        .then(api => {
          let params = {
            agentId: this.editableResource.agentId,
            agentStore: this.editableResource.agentStore,
            agentComments: this.editableResource.agentComments,
            customerComments: this.editableResource.customerComments,
            sendMessagesToCustomers: this.editableResource.sendMessagesToCustomers,
            createTasks: this.editableResource.createTasks,
            doStoreTransfer: this.editableResource.doStoreTransfer,
          };
          return api.post(`/orders/${this.orderId}/check-in`, params);
        })
        .then(() => {
          this.checkInDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "ההחזרה הושלמה בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initEditableResource() {
      this.editableResource = {
        sendMessagesToCustomers: true,
        createTasks: true,
        doStoreTransfer: true
      }
    }
  },

  mounted() {
    this.initEditableResource();
  },

  props: ["orderId"],

  mixins: [Mixins],

  watch: {
    checkInDialog: {
      handler: function(val) {
        if (!val) {
          this.initEditableResource();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
